/* eslint-disable */
import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { Routes, Route, Navigate } from 'react-router-dom';
import themes from 'themes';
import HrLayout from 'layout/HrLayout';
import HrExpenses from 'views/hr/HrExpenses';
import ProtectedHrRoute from 'routes/ProtectedHrRoute';

const HrPortal = () => {
    const customization = useSelector((state) => state.customization);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <Routes>
                    <Route
                        path="/"
                        element={
                            <ProtectedHrRoute>
                                <HrLayout />
                            </ProtectedHrRoute>
                        }
                    >
                        <Route index element={<Navigate to="expenses" replace />} />
                        <Route path="expenses" element={<HrExpenses />} />
                    </Route>
                </Routes>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default HrPortal;    